const squiggleSvg = `<svg preserveAspectRatio="none" style="width: 100%; height: 100%; color: inherit;" viewBox="0 0 420 117" fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <g opacity="0.2">
    <path pathLength="1" style="stroke: currentColor; color: inherit; transition: all .5s ease .5s;"
      d="M3.44108 52.2148C265.377 43.4588 417.468 39.6462 417.598 42.6223C417.803 47.4127 23.7566 65.4454 24.0474 74.7863C24.1781 78.9614 103.059 80.8581 283.82 79.7234"
      stroke-width="5" stroke-miterlimit="10" />
  </g>
  <defs>
  </defs>
</svg> `;

const swish1Svg = `
<svg class='swish_1' preserveAspectRatio="none" viewBox="0 0 321 58" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g opacity="0.2" clip-path="url(#clip0_130_964)">
    <path pathLength="1" style="stroke: currentColor; color: inherit;"
      d="M1.20526 38.4461C61.028 26.6292 128.023 18.1608 201.028 16.5603C243.022 15.6429 282.783 17.0867 320.066 20.1734"
      stroke-width="5" stroke-miterlimit="10" />
  </g>
</svg>
`;

const swish2Svg = `
  <svg class='swish_2' preserveAspectRatio="none" viewBox="0 0 257 74" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g opacity="0.4" clip-path="url(#clip0_130_968)">
    <path pathLength="1" style="stroke: currentColor; color: inherit;"
      d="M0.883519 37.3891C49.5871 29.014 103.681 24.3766 161.911 26.9134C195.405 28.3757 226.9 32.0614 256.27 37.2418"
      stroke-width="5" stroke-miterlimit="10" />
  </g>
  <defs>
  </defs>
</svg>
`;

const circle = `
<svg class="circle" preserveAspectRatio="none" viewBox='0 0 374.12 138.06' fill='none' xmlns='http://www.w3.org/2000/svg'>
  <path opacity='0.2'
    style='stroke: currentColor; color: inherit;'
    pathLength='1'
    d='M371.51,50.61c.8,8.05-2.96,16.57-11.32,25.19-8.35,8.6-21.02,17-37.19,24.65-32.32,15.3-78.07,27.4-129.56,32.54-51.49,5.14-98.72,2.34-133.43-6.27-17.37-4.31-31.44-10.03-41.33-16.81-9.9-6.79-15.27-14.4-16.08-22.45-.8-8.05,2.96-16.57,11.32-25.19,8.35-8.6,21.01-17,37.19-24.65C83.44,22.31,129.18,10.22,180.67,5.07c51.49-5.14,98.72-2.34,133.43,6.27,17.37,4.31,31.44,10.03,41.33,16.81,9.9,6.79,15.27,14.4,16.08,22.45Z' 
    stroke-width='5' />
</svg>
`;

const Marks = () => {
  const markContainers = document.querySelectorAll("[data-mark-type]");

  markContainers.forEach((title) => {
    const markType = title.dataset.markType;
    const marks = title.querySelectorAll("mark");

    marks.forEach((mark) => {
      if (markType === "squiggle") {
        // append squiggle to mark
        mark.innerHTML = `${mark.innerHTML} ${squiggleSvg}`;
      }

      if (markType === "swish_1") {
        // append swish to mark
        mark.innerHTML = `${mark.innerHTML} ${swish1Svg}`;
      }

      if (markType === "swish_2") {
        // append swish to mark
        mark.innerHTML = `${mark.innerHTML} ${swish2Svg}`;
      }

      if (markType === "circle") {
        // append circle to mark
        mark.innerHTML = `${mark.innerHTML} ${circle}`;
      }
    });
  });
};

export default Marks;
